var render = function render(_c,_vm){return _c('div',{staticClass:"cell",class:{
    highlighted: _vm.props.highlighted,
    'with-source-indicator': _vm.props.indicator,
    [`source-${_vm.props.indicator}`]: _vm.props.indicator,
    inherited: _vm.props.inherited,
  }},[_c('div',{staticClass:"cell-wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default",function(){return [_c('span',{staticClass:"placeholder"},[_vm._v(" "+_vm._s(_vm.props.placeholder)+" ")])]}),(_vm.props.indicator)?_c('div',{staticClass:"source-indicator-wrapper"},[_c('div',{staticClass:"source-indicator",class:_vm.props.indicator})]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }